import React from 'react'
import classNames from 'classnames'
import CardModal from 'components/CardModal'
import AugmentationEditorBlur from './AugmentationEditorBlur'
import AugmentationEditorNoise from './AugmentationEditorNoise'
import AugmentationEditorDenoise from './AugmentationEditorDenoise'
import AugmentationEditorExposure from './AugmentationEditorExposure'
import StaticImagePreview from 'images/img-augmentation_preview.png'
import { getPreviewStyle, renderCutouts, renderCrop } from './utils'

const AugmentationEditorPreview = ({ selectedOption, color }) => {
  const getValues = getPreviewStyle(selectedOption)
  const isImage = !(selectedOption.key === 'augment_blur' || selectedOption.key === 'augment_noise' || selectedOption.key === 'augment_denoise' || selectedOption.key === 'augment_exposure')

  return (
    <div className={classNames('augmentation-editor__preview')}>
      <CardModal
        title='Preview'
        titleClass='modal__title_label'
        classNames='modal__frame--full'
        body={(
          <div className={classNames('augmentation-editor-preview', isImage && 'augmentation-editor-preview--image')}>
            {isImage &&
              <img
                className='augmentation-editor-preview__image'
                src={StaticImagePreview}
                style={getValues}
              />
            }
            {selectedOption.key === 'augment_cutout' && renderCutouts(getValues)}
            {selectedOption.key === 'augment_crop' && renderCrop(getValues)}
            {selectedOption.key === 'augment_blur' && <AugmentationEditorBlur selectedOption={selectedOption} previewImage={StaticImagePreview} color={color} />}
            {selectedOption.key === 'augment_noise' && <AugmentationEditorNoise selectedOption={selectedOption} previewImage={StaticImagePreview} color={color} />}
            {selectedOption.key === 'augment_denoise' && <AugmentationEditorDenoise selectedOption={selectedOption} previewImage={StaticImagePreview} color={color} />}
            {selectedOption.key === 'augment_exposure' && <AugmentationEditorExposure selectedOption={selectedOption} previewImage={StaticImagePreview} color={color} />}
          </div>
        )}
      />
    </div>
  )
}

export default AugmentationEditorPreview